import axios from 'axios';
import { searchAPI } from '@/providers/apis/search/search';
import { contentAPI } from '@/providers/apis/content/content';

export default {
    namespaced: true,
    state: {
        googleSearch: [],
        bingSearch: [],
        gooruSearch: [],
        gradeList: [],
        summary: [],
        transcript: [],
    },

    mutations: {

        googleSearch(state: any, searchContent: any) {
            if (searchContent.isScroll) {
                searchContent.data = state.googleSearch.concat(searchContent.data);
            }
            state.googleSearch = searchContent.data;
        },

        bingSearch(state: any, searchContent: any) {
            if (searchContent.isScroll) {
                searchContent.data = state.bingSearch.concat(searchContent.data);
            }
            state.bingSearch = searchContent.data;
        },

        comparativeSearch(state: any, search: any) {
            state.gooruSearch = search;
        },

        getGradeList(state: any, gradeList: any) {
            state.gradeList = gradeList;
        },
        getSummary(state: any, summary: any) {
            state.summary = summary;
        },

        getTranscript(state: any, transcript: any) {
         state.transcript = transcript;
        },

        reset(state: any) {
          state.bingSearch = [];
          state.googleSearch = [];
          state.googleSearch = [];
        },
    },

    actions: {

        googleSearch(context: any, filter: any) {
            searchAPI.googleSearch(filter.params.q, filter.params.start).then((search) => {
                context.commit('googleSearch', {
                    isScroll: filter.isScroll,
                    data: search.items,
                });
            });
        },
        bingSearch(context: any, filter: any) {
            searchAPI.bingSearch(filter.params.q, filter.params.start).then((search) => {
                context.commit('bingSearch', {
                    isScroll: filter.isScroll,
                    data: search.items,
                });
            });
        },

        comparativeSearch(context: any, params: any) {
            searchAPI.fetachLearnerContents(params)
                .then((search) => {
                    context.commit('comparativeSearch', search);
                });
        },

        getGradeList(context: any) {
            contentAPI.getGradeList().then((gradeList) => {
                context.commit('getGradeList', gradeList);
            });
        },

        getSummary(context: any , params: any) {
            contentAPI.fetchSummary(params).then((resource) => {
                context.commit('getSummary', resource);
            });
        },

        getTranscript(context: any , params: any) {
            contentAPI.fetchTranscript(params).then((transcript) => {
                context.commit('getTranscript', transcript);
            });
        },
    },
};
